<template>
  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-col :md="24" :lg="16">

        <a-form layout="vertical"  :form="form" >
          <a-form-item
            label="原密码"
          >
            <a-input type="password" placeholder="请输入原密码"  v-decorator="[
          'old_password',
          {rules: [{ required: true, message: '请输入原密码' }]}
        ]"
                     />
          </a-form-item>

          <a-form-item
            label="新密码"
          >
            <a-input type="password"  v-decorator="[
          'password',
          {rules: [{ required: true, message: '请输入新密码' }]}
        ]"   placeholder="请输入新密码"    />
          </a-form-item>

          <a-form-item
            label="再次输入"
          >
            <a-input type="password" v-decorator="[
          'password2',
          {rules: [{ required: true, message: '请再次输入新密码' }]}
        ]"  placeholder="请再次输入新密码"    />
          </a-form-item>

          <a-form-item>
            <a-button type="primary"  :loading="saveLoading" @click="submitForm">保存</a-button>
          </a-form-item>
        </a-form>

      </a-col>
      <a-col :md="24" v-if="false" :lg="8" :style="{ minHeight: '180px' }">
        <div class="ant-upload-preview" @click="$refs.modal.edit(1)" >
          <a-icon type="cloud-upload-o" class="upload-icon"/>
          <div class="mask">
            <a-icon type="plus" />
          </div>
          <img :src="option.img"/>
        </div>
      </a-col>

    </a-row>

  </div>
</template>

<script>

  import { editPassword } from '@/api/user'
  import RSwitch from '@/components/RSwitch/'
  import PicUploader from '@/components/PicUploader/'
  export default {
    components: {
      PicUploader,
      RSwitch
    },
    data () {
      return {
        // cropper
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        saveLoading:false,
        form: this.$form.createForm(this),
        preview: {},
        option: {
        },
        formData:{
          old_password:'',
          password:'',
          password2:'',
        }
      }
    },
    mounted(){
      let that = this;
    },
    methods: {

      submitForm(e){
        let self = this
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            self.saveLoading = true;
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
          editPassword(Object.assign(self.formData,values)).then(res => {
              self.$message.success('设置成功')
              self.saveLoading = false
              window.location.reload()
            }).catch(err =>{
              self.$message.error(err.data.msg)
              self.saveLoading = false
            })
          }else{
            console.log(err)
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>

  .avatar-upload-wrapper {
    height: 200px;
    width: 100%;
  }

  .ant-upload-preview {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 180px;
    border-radius: 50%;
    box-shadow: 0 0 4px #ccc;

    .upload-icon {
      position: absolute;
      top: 0;
      right: 10px;
      font-size: 1.4rem;
      padding: 0.5rem;
      background: rgba(222, 221, 221, 0.7);
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .mask {
      opacity: 0;
      position: absolute;
      background: rgba(0,0,0,0.4);
      cursor: pointer;
      transition: opacity 0.4s;

      &:hover {
        opacity: 1;
      }

      i {
        font-size: 2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -1rem;
        margin-top: -1rem;
        color: #d6d6d6;
      }
    }

    img, .mask {
      width: 100%;
      max-width: 180px;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
    }
  }
</style>